import styled, { css, keyframes } from 'styled-components'

// ===== COLORS =====
export const ALMOST_WHITE = '#f2f6f8'
export const LIGHTEST_GRAY = '#e0e0e0'
export const LIGHTER_GRAY = '#d3d3d3'
export const LIGHT_GRAY = '#bbb'
export const GRAY = '#636363'
export const DARK_GRAY = '#4A4A4A'
export const RED = '#ee5951'
export const PURPLE = '#4F5DBA'

export const SHOPIFY_GRAY = '#F6F7F9'
export const SHOPIFY_BLUE = '#5c6ac4'
export const SHOPIFY_RED = '#ee6b50'
export const SHOPIFY_TEAL = '#83cbca'

export const SHOPIFY_TEXT_HEADER = '#212b36'
export const SHOPIFY_TEXT = '#637381'





export const TEAL = '#83CBCA'

export const BLUE = '#3899EC'
// used for hover on buttons
export const LIGHT_BLUE = '#4eb7f5'

// ===== FONTS ====
export const HELVETICA = css`
  font-family: HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,Helvetica,Arial,meiryo,hiragino kaku gothic pro,"sans-serif";
`
export const HELVETICA_ITALIC = css`
  font-family: 'HelveticaNeue-UltraLightItalic', 'Helvetica', sans-serif;
`
export const SANS_SERIF = css`
  font-family: 'Open Sans', sans-serif;
`

// ===== MEDIA QUERIES FACTORY =====
export const media = {
  small: (...args) => css`
    ${css(...args)}
  `,
  normal: (...args) => css`
    @media (min-width: 1400px) {
      ${css(...args)}
    }
  `,
  huge: (...args) => css`
    @media (min-width: 2000px) {
      ${css(...args)}
    }
  `
}
export const fontSize = css`
  font-size: 12px;
  @media (min-width: 1400px){
    font-size: 15px;
  };
  @media (min-width: 2000px){
    font-size: 18px;
  };
`
// ===== ANIMATIONS =====
// FADE-IN animation
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`
export const fadeInAnimation = css`
  animation: ${fadeIn} ${props => props.animationDuration || '0.25s'} ease-out both;
  ${props => props.animationDelay ? `animation-delay: ${props.animationDelay}` : ''}
`
// SCALE-UP animation
const scaleUp = keyframes`
  from { transform: scale(0.75); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`
export const scaleUpAnimation = css`
  animation: ${scaleUp} ${props => props.animationDuration || '0.25s'} ease-out both;
  ${props => props.animationDelay ? `animation-delay: ${props.animationDelay}` : ''}
`

// ===== COMPONENTS =====
// Used with Tooltip to show hints
export const IconCircle = styled.div`
  border: 1px solid ${LIGHTER_GRAY};
  border-radius: 50%;
  width: 20px;
  height: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${GRAY};
  ${HELVETICA_ITALIC}
  font-weight: 100;
  font-size: 14px;
  user-select: none;
`

export const CustomScrollBar = `
  ::-webkit-scrollbar {
      width: 8px;
  }
  ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
      border-radius: 10px;
      background-color: white;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 15px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.25);
  }
`



// WEBPACK FOOTER //
// ./src/components/styles.js